export default class ScrollClassToggler {
  constructor(element, classToAdd, scrollPercentage, debounceDelay) {
    this.element = element;
    this.classToAdd = classToAdd;
    this.scrollPercentage = scrollPercentage;
    this.debounceDelay = debounceDelay;
    this.maxVerticalScroll = Math.floor(
      window.innerHeight * (scrollPercentage / 100)
    );
  }

  toggleClass() {
    const verticalScrollPosition = window.scrollY;

    if (verticalScrollPosition > this.maxVerticalScroll) {
      this.element.classList.add(this.classToAdd);
    } else {
      this.element.classList.remove(this.classToAdd);
    }
  }

  debounce(func, delay) {
    let timer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    };
  }

  init() {
    window.addEventListener(
      'scroll',
      this.debounce(this.toggleClass.bind(this), this.debounceDelay)
    );
  }
}
